document.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-card-atc-btn');
  if (!btn) return;
  e.preventDefault();
  btn.classList.add('loading');
  const spinner = btn.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');
  const wrapper = btn.closest('.card-wrapper.product-card-wrapper');
  const quickAddBtn = wrapper?.querySelector('.quick-add__submit');
  if (quickAddBtn) {
    let handled = false;
    const stopLoading = () => {
      if (handled) return;
      handled = true;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    };
    quickAddBtn.click();
    setTimeout(stopLoading, 1200);
    quickAddBtn.closest('form')?.addEventListener('submit', stopLoading, { once: true });
  }
});



document.addEventListener("DOMContentLoaded", function(){
  const addon = document.querySelector('.addon-product');
  const atcWrapper = document.querySelector('.atc-btn-with-qty-selector');
  if(!addon || !atcWrapper) return;
  const checkbox = addon.querySelector('.addon-checkbox');
  const staticBtn = atcWrapper.querySelector('.static-atc-btn');
  const dynamicBtn = atcWrapper.querySelector('.product-form__submit:not(.static-atc-btn)');
  function toggleATC() {
    if(checkbox.checked){
      staticBtn.style.display = 'flex';
      dynamicBtn.style.display = 'none';
    } else {
      staticBtn.style.display = 'none';
      dynamicBtn.style.display = 'flex';
    }
  }
  toggleATC();
  checkbox.addEventListener('change', toggleATC);
});
document.addEventListener("DOMContentLoaded", function(){
  const addon = document.querySelector('.addon-product');
  const atcWrapper = document.querySelector('.atc-btn-with-qty-selector');
  if(!addon || !atcWrapper) return;
  const checkbox = addon.querySelector('.addon-checkbox');
  const staticBtn = atcWrapper.querySelector('.static-atc-btn');
  const dynamicBtn = atcWrapper.querySelector('.dynamic-atc-btn');
  if(!staticBtn || !dynamicBtn) return;
  staticBtn.addEventListener('click', function(e){
    e.preventDefault();
    const btn = this;
    const spinner = btn.querySelector('.loading__spinner');
    btn.classList.add('loading');
    spinner?.classList.remove('hidden');
    const addonId = addon.dataset.addonId;
    const qtyInput = addon.querySelector('.addon-qty input');
    const addonQty = parseInt(qtyInput?.value) || 1;
    if(!addonId){
      console.warn('Addon ID missing');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: addonId,
        quantity: addonQty
      })
    })
    .then(res => res.json())
    .then(() => {
      dynamicBtn.style.display = 'block';
      dynamicBtn.click();
      setTimeout(() => {
        dynamicBtn.style.display = 'none';
      }, 100);
      btn.classList.remove('loading');
      spinner?.classList.add('hidden');
    })
    .catch(() => {
      btn.classList.remove('loading');
      spinner?.classList.add('hidden');
    });

  });

});